<template>
    <div class="wrapper padding-sm bg-white">
        <div class="flex align-start justify-between margin-bottom">
            <h3 class="page-title line-height">分支机构聘书</h3>
            <el-button class="blue-btn" round type="primary" @click="$router.go(-1)">返回
            </el-button>
        </div>
        <el-image v-if="certificate" :src="imgUrl + certificate" alt="" class="certificate">
            <div slot="error">
                <el-empty description="暂无聘书"></el-empty>
            </div>
        </el-image>
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="form margin-top" label-width="auto">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="聘书名称" prop="cert_name">
                        <el-input v-model="ruleForm.cert_name" placeholder="请输入聘书名称"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="聘书编号" prop="cert_code">
                        <el-input v-model="ruleForm.cert_code" placeholder="请输入聘书编号"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="发证单位" prop="cert_company">
                        <el-input v-model="ruleForm.cert_company" placeholder="请输入发证单位"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="发证时间" prop="cert_date">
                        <el-date-picker
                            v-model="ruleForm.cert_date"
                            placeholder="请选择发证时间"
                            style="width: 100%"
                            type="date"
                            value-format="timestamp">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="聘书内容" prop="cert_content">
                <el-input v-model="ruleForm.cert_content" :autosize="{ minRows: 6, maxRows: 6 }" placeholder="请输入聘书内容" resize="none"
                          type="textarea">
                </el-input>
            </el-form-item>
        </el-form>
        <div class="flex align-center justify-center">
            <el-button :loading="loading" class="blue-btn" @click="submitForm('ruleForm')">
                提交信息
            </el-button>
        </div>
    </div>
</template>

<script>
import {getFhPinShu,getPinShuDetail,upPinShuDetail} from "@/api/organiz";
import {IMAGE_PATH} from "@/config";

export default {
    name: "certificate",
    data() {
        return {
            certificate: '',
            noCertificate: false,
            loading: false,
            ruleForm: {
                cert_name: '',
                cert_code: '',
                cert_company: '',
                cert_date: '',
                cert_content: '',
            },
            rules: {
                cert_name: [
                    {required: true, message: '请输入聘书名称', trigger: 'blur'},
                ],
                cert_code: [
                    {required: true, message: '请输入聘书编号', trigger: 'blur'},
                ],
                cert_company: [
                    {required: true, message: '请输入发证单位', trigger: 'blur'},
                ],
                cert_date: [
                    {required: true, message: '请选择发证时间', trigger: 'blur'},
                ],
                cert_content: [
                    {required: true, message: '请输入聘书内容', trigger: 'blur'},
                    {min: 5, message: '意见建议至少为 5 个字符', trigger: 'blur'}
                ]
            },
        }
    },

    created() {
        this.$emit('setIndex', [8, 0], '分支机构聘书')
        this.getCertificate()
        this.init()

    },
    computed: {
        imgUrl() {
            return IMAGE_PATH
        },
    },
    components: {},
    methods: {
        async init() {
            let _data = await getPinShuDetail(this.$route.params.id)
            if (_data.status === 200) {
                this.ruleForm.cert_name = _data.data.pinshu_name
                this.ruleForm.cert_code = _data.data.pinshu_code
                this.ruleForm.cert_company = _data.data.pinshu_company
                this.ruleForm.cert_date = _data.data.pinshu_date ? _data.data.pinshu_date * 1000 : ''
                this.ruleForm.cert_content = _data.data.pinshu_content
            }
        },
        async getCertificate() {
            let _data = await getFhPinShu(this.$route.params.id)
            if (_data.status === 200) {
                this.certificate = _data.data + '?v=' + new Date().getTime()
            } else {
                this.noCertificate = true
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.upUserCertDetail();
                }
            });
        },
        async upUserCertDetail(){
            this.loading = true
            let _data = await upPinShuDetail(this.$route.params.id, this.ruleForm.cert_name, this.ruleForm.cert_content,
                this.ruleForm.cert_code, this.ruleForm.cert_company, this.ruleForm.cert_date / 1000)
            this.loading = false
            if (_data.status === 200) {
                this.$message.success(_data.msg)
                this.getCertificate()
            }
        },
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.certificate {
    width: 100%;
}
</style>